import { ReferenceData } from './reference-data.model';

export class ScaleId extends ReferenceData {

  locationId: string;
  dsnyLocationId: { correlation: string };
  nonTransmitting: boolean;

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.locationId = data.locationId;
    this.dsnyLocationId = data.dsnyLocationId;
    this.nonTransmitting = data.nonTransmitting ? data.nonTransmitting : false;
  }
}
